import { render } from "./WorkList.vue?vue&type=template&id=8951502a&scoped=true"
import script from "./WorkList.vue?vue&type=script&lang=js"
export * from "./WorkList.vue?vue&type=script&lang=js"

import "./WorkList.vue?vue&type=style&index=0&id=8951502a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8951502a"

export default script